const mediaItems = [
  {
    title: '某顶流艺人深夜与神秘女子同回住所，疑似新恋情浮出水面',
    views: '128.6万',
    time: '3小时前',
    tag: '明星八卦',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20thumbnail%20composition%20of%20trending%20celebrity%20entertainment%20news%20with%20abstract%20geometric%20shapes%20and%20warm%20coral%20gradient%20overlay%20modern%20editorial%20design%20with%20video%20play%20icon%20element%20clean%20minimalist%20aesthetic%20against%20soft%20warm%20beige%20background%20high%20quality%20digital%20art&width=400&height=250&seq=media-card-01&orientation=landscape',
  },
  {
    title: '热门综艺录制现场突发意外，导演组紧急叫停引热议',
    views: '96.3万',
    time: '5小时前',
    tag: '综艺爆料',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20entertainment%20news%20visual%20with%20floating%20text%20placeholder%20elements%20and%20dynamic%20diagonal%20composition%20in%20amber%20and%20terracotta%20tones%20modern%20magazine%20editorial%20style%20thumbnail%20with%20video%20frame%20overlay%20artistic%20warm%20lighting%20and%20sophisticated%20layout&width=400&height=250&seq=media-card-02&orientation=landscape',
  },
  {
    title: '年度最劲爆大瓜！某知名夫妻档被曝已秘密离婚三年',
    views: '215.7万',
    time: '8小时前',
    tag: '深度爆料',
    img: 'https://readdy.ai/api/search-image?query=Contemporary%20entertainment%20media%20card%20design%20with%20abstract%20wave%20patterns%20and%20warm%20rose%20gold%20gradient%20accents%20modern%20editorial%20thumbnail%20featuring%20dynamic%20geometric%20elements%20and%20subtle%20texture%20on%20soft%20cream%20background%20sophisticated%20digital%20composition&width=400&height=250&seq=media-card-03&orientation=landscape',
  },
  {
    title: '网红圈又出大瓜！千万粉丝博主被前合伙人力锤造假',
    views: '187.2万',
    time: '10小时前',
    tag: '网红风云',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20entertainment%20news%20thumbnail%20with%20layered%20abstract%20shapes%20and%20warm%20sunset%20gradient%20tones%20featuring%20modern%20video%20player%20interface%20elements%20elegant%20editorial%20design%20with%20coral%20and%20amber%20accents%20on%20light%20neutral%20background%20high%20quality%20visual&width=400&height=250&seq=media-card-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            精彩爆料
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            51吃瓜视频网最新热门爆料视频速览
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-md bg-accent-500/90 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 w-9 h-9 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500">
                  <i className="ri-play-fill text-base"></i>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 leading-snug line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span>{item.time}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}